import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-title" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = {
  key: 0,
  class: "trezo-card-subtitle mt-[15px] sm:mt-0"
}
const _hoisted_6 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_7 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_8 = { class: "trezo-card-content" }
const _hoisted_9 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_10 = {
  key: 1,
  class: "text-center py-4 text-gray-500 dark:text-gray-400"
}
const _hoisted_11 = {
  key: 2,
  class: "table-responsive overflow-x-auto"
}
const _hoisted_12 = { class: "w-full" }
const _hoisted_13 = { class: "text-black dark:text-white" }
const _hoisted_14 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md" }
const _hoisted_15 = { class: "font-medium ltr:text-center rtl:text-center px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_16 = { class: "font-medium ltr:text-right rtl:text-left px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_17 = { class: "font-medium ltr:text-right rtl:text-left px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tr-md" }
const _hoisted_18 = { class: "text-black dark:text-white" }
const _hoisted_19 = { class: "ltr:text-left rtl:text-right px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = { class: "rounded-md w-[40px] h-[40px] overflow-hidden flex-shrink-0" }
const _hoisted_22 = ["src", "onError"]
const _hoisted_23 = { class: "ltr:ml-[12px] rtl:mr-[12px] flex-grow min-w-0" }
const _hoisted_24 = { class: "block font-medium md:text-[15px] truncate" }
const _hoisted_25 = {
  key: 0,
  class: "text-xs text-gray-500 dark:text-gray-400 mt-1 block truncate"
}
const _hoisted_26 = {
  key: 1,
  class: "text-xs text-gray-400 mt-1 block"
}
const _hoisted_27 = { class: "ltr:text-center rtl:text-center whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_28 = { class: "ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_29 = { class: "ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_30 = {
  key: 0,
  class: "bg-gray-50 dark:bg-[#15203c]"
}
const _hoisted_31 = {
  colspan: "3",
  class: "ltr:text-right rtl:text-left font-medium px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036]"
}
const _hoisted_32 = { class: "ltr:text-right rtl:text-left font-medium px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.directT('ecommerce.orderDetails.productsInOrder')), 1)
      ]),
      (_ctx.order)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.order.customer_id)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_6, _toDisplayString(_ctx.directT('ecommerce.orderDetails.customerID')) + ": " + _toDisplayString(_ctx.order.customer_id), 1))
              : _createCommentVNode("", true),
            (!_ctx.order.customer_id && _ctx.order.name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.directT('ecommerce.orderDetails.customer')) + ": " + _toDisplayString(_ctx.order.name), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "animate-spin rounded-full h-6 w-6 border-b-2 border-primary-500 mx-auto" }, null, -1)
          ])))
        : (!_ctx.orderProducts || _ctx.orderProducts.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.directT('ecommerce.orderDetails.noItemsFound') || 'No items found in this order'), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("table", _hoisted_12, [
                _createElementVNode("thead", _hoisted_13, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.directT('ecommerce.orderDetails.product')), 1),
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.directT('ecommerce.orderDetails.quantity')), 1),
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.directT('ecommerce.orderDetails.price')), 1),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.directT('ecommerce.orderDetails.total')), 1)
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderProducts, (product, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: product.id || index
                    }, [
                      _createElementVNode("td", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("img", {
                              src: product.image || _ctx.getFallbackProductImage(index),
                              class: "inline-block rounded-md object-cover w-full h-full",
                              alt: "product-image",
                              onError: ($event: any) => (_ctx.onImageError($event, index))
                            }, null, 40, _hoisted_22)
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("span", _hoisted_24, _toDisplayString(product.name || `Product ${index + 1}`), 1),
                            (product.description)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.truncateText(product.description, 30)), 1))
                              : _createCommentVNode("", true),
                            (product.id)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_26, " ID: " + _toDisplayString(_ctx.truncateText(product.id, 10)), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(product.quantity || 1), 1),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.formatPrice(product.price)), 1),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.formatPrice(product.price * (product.quantity || 1))), 1)
                    ]))
                  }), 128)),
                  (_ctx.orderProducts.length > 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                        _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.directT('ecommerce.orderDetails.total')) + ": ", 1),
                        _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.formatPrice(_ctx.calculateTotal())), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
    ])
  ]))
}